import { ConnectServicePage } from "@/features/integrations/connect-service.page";
import { createFileRoute } from "@tanstack/react-router";

/**
 * CR-288: the deep link an integration listing points at (Notion's listing →
 * /connect/notion). Under _authenticated, so a signed-out visitor goes through
 * /login?redirect= and comes back here. `$service` is URL input: the page
 * checks it against the known services.
 */
export const Route = createFileRoute("/_authenticated/connect/$service")({
  component: ConnectServiceRoute,
});

function ConnectServiceRoute() {
  const { service } = Route.useParams();
  return <ConnectServicePage service={service} />;
}
